(function () {
    'use strict';

    angular
        .module('corporateRoleModule')
        .controller('CorporateRoleFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$mdToast', 'corporateRoleService', 'permissionService'];

    function Controller($rootScope, $scope, $state, $mdToast, corporateRoleService, permissionService) {

        $scope.canEdit = permissionService.hasPermission('ProceduresManagement', 'CorporateRole', 'Edit');
        
        // Select Owner
        $scope.selectOwner = function (person) {
            $scope.boxModel.Person = person;
            $scope.boxModel.PersonID = person.ItemPersonID;
            $scope.pageIsDirty();
        }

        // Show Reset Action?
        $scope.showResetAction = function () {
            if (!$scope.canEdit) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Reset forms
        $scope.reset = function () {
            $scope.isLoading = true;
            $state.reload();
        }


        $scope.pageIsDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };
        $scope.pageIsNotDirty = function () {
            $scope.ctxtCtrl.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Show Save Action
        $scope.showSaveAction = function (form) {
            if (!$scope.canEdit) return false;
            if (!$scope.boxModel.CorporateRoleID) return false;
            if (form.$invalid) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        }

        // Show Add Action
        $scope.showAddAction = function (form) {
            
            if ($scope.boxModel.CorporateRoleID) return false;
            if (form.$invalid) return false;

            return $scope.canEdit;
        }

        // Create Or Update
        $scope.createOrUpdate = function () {
            $scope.isLoading = true;
            $scope.boxModel.ItemOrderID = $scope.boxModel.DisplayItemOrderID;

            corporateRoleService
                .createOrUpdateCorporateRole($scope.boxModel)
                .then(function (updatedCorporateRole) {

                    if (_.isUndefined($scope.boxModel.CorporateRoleID)) {
                        $state.go('corporateRole', { CorporateRoleID: updatedCorporateRole.CorporateRoleID, SkipDirtyCheck: true });
                    }
                    else {

                        $mdToast.show(
                            $mdToast
                                .simple()
                                .content('Your changes have been saved!')
                                .position('top right')
                                .hideDelay($scope.govNotificationDelay)
                                .action('OK')
                                .theme('primary')
                        );

                        $scope.pageIsNotDirty();
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

    }

})();